export default __webpack_public_path__ + "static/media/background-desktop.afe62aa8.svg";